import React, { Component, MouseEvent, ChangeEvent } from "react";
import abreakfast from './Images/aspritz-breakfast.jpeg';
import dbreakfast from './Images/deepsea-breakfast.jpeg';
import sbreakfast from './Images/silver-lin-breakfast.jpeg';
import amorning from './Images/aspritz-morning.jpeg';
import dmorning from './Images/deepsea-morning.jpeg';
import smorning from './Images/silver-linings-morning.jpeg';
import alunch from './Images/alunch.jpeg';
import dlunch from './Images/dlunch.jpeg';
import slunch from './Images/slunch.jpeg';
import adinner from './Images/adinner.jpeg';
import ddinner from './Images/ddinner.jpeg';
import sdinner from './Images/sdinner.jpeg';
import aafternoon from './Images/a-afternoon.jpeg';
import dafternoon from './Images/d-afternoon.jpeg';
import safternoon from './Images/s-afternoon.jpeg';
import aevening from './Images/a-evening.jpeg';
import devening from './Images/d-evening.jpeg';
import sevening from './Images/s-evening.jpeg';

type QuizPageProps = {
    onFinishClick: (score: number[]) => void;
};

type QuizPageState = {
    score: number[];
};

export class QuizPage extends Component<QuizPageProps, QuizPageState> {

    constructor(props: QuizPageProps) {
        super(props);

        this.state = {
            score: [0, 0, 0]
        };
    }
    
    render = (): JSX.Element => {
        return (
            <div>
                <div className="Q1">
                    <h3>What are you having for breakfast?</h3>
                    <label>
                    <input type="radio" name="q1" onChange={this.doDeepSeaClick}/>
                    <img src={dbreakfast} className="image" alt="house2"/>
                    </label>
                    <label>
                    <input type="radio" name="q1" onChange={this.doASpritzClick}/>
                    <img src={abreakfast} className="image" alt="house1"/>
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q1" onChange={this.doSilverLiningsClick}/>
                    <img src={sbreakfast} className="image" alt="house3"/>
                    </label>
                </div>

                <div className="Q2">
                    <h3>Where are you spending your morning?</h3>
                    <label>
                    <input type="radio" name="q2" onChange={this.doASpritzClick}/>
                    <img src={amorning} className="image" alt="backyard1"/>
                    </label>
                    <label>
                    <input type="radio" name="q2" onChange={this.doDeepSeaClick}/>
                    <img src={dmorning} className="image" alt="backyard2"/>
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q2" onChange={this.doSilverLiningsClick}/>
                    <img src={smorning} className="image" alt="backyard3"/>
                    </label>
                </div>

                <div className="Q3">
                    <h3>What's for lunch?</h3>
                    <label>
                    <input type="radio" name="q3" onChange={this.doSilverLiningsClick}/>
                    <img src={slunch} className="image" alt="livingroom3"/>
                    </label>
                    <label>
                    <input type="radio" name="q3" onChange={this.doDeepSeaClick}/>
                    <img src={dlunch} className="image" alt="livingroom2"/>
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q3" onChange={this.doASpritzClick}/>
                    <img src={alunch} className="image" alt="livingroom1"/>
                    </label>
                </div>

                <div className="Q4">
                    <h3>Where are you going in the afternoon?</h3>
                    <label>
                    <input type="radio" name="q4" onChange={this.doASpritzClick}/>
                    <img src={aafternoon} className="image" alt="diningroom1"/>
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q4" onChange={this.doSilverLiningsClick}/>
                    <img src={safternoon} className="image" alt="diningroom3"/>
                    </label>
                    <label>
                    <input type="radio" name="q4" onChange={this.doDeepSeaClick}/>
                    <img src={dafternoon} className="image" alt="diningroom2"/>
                    </label>
                </div>

                <div className="Q5">
                    <h3>Dinner?</h3>
                    <label>
                    <input type="radio" name="q5" onChange={this.doASpritzClick}/>
                    <img src={adinner} className="image" alt="kitchen1"/>
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q5" onChange={this.doSilverLiningsClick}/>
                    <img src={sdinner} className="image" alt="kitchen3"/>
                    </label>
                    <label>
                    <input type="radio" name="q5" onChange={this.doDeepSeaClick}/>
                    <img src={ddinner} className="image" alt="kitchen2"/>
                    </label>
                </div>
                <div className="Q7">
                    <h3>WHat are you doing in the evening?</h3>
                    <label>
                    <label>
                    <input type="radio" name="q7" onChange={this.doDeepSeaClick}/>
                    <img src={devening} className="image" alt="bedroom2"/>
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q7" onChange={this.doSilverLiningsClick}/>
                    <img src={sevening} className="image" alt="bedroom3"/>
                    </label>
                    <input type="radio" name="q7" onChange={this.doASpritzClick}/>
                    <img src={aevening} className="image" alt="bedroom1"/>
                    </label>
                </div>

                <p></p>


                <button onClick={this.doFinishClick}>Finish</button>
            </div>
        )
    }

    doASpritzClick = (_evt: ChangeEvent<HTMLInputElement>): void => {
        this.setState({score: [this.state.score[0] + 1, this.state.score[1], this.state.score[2]]});
    }

    doDeepSeaClick = (_evt: ChangeEvent<HTMLInputElement>): void => {
        this.setState({score: [this.state.score[0], this.state.score[1] + 1, this.state.score[2]]});
    }

    doSilverLiningsClick = (_evt: ChangeEvent<HTMLInputElement>): void => {
        this.setState({score: [this.state.score[0], this.state.score[1], this.state.score[2] + 1]});
    }

    doFinishClick = (_evt: MouseEvent<HTMLButtonElement>): void => {
        this.props.onFinishClick(this.state.score);
    }
}